<app-content-area
  [title]="'EMPLOYEE_LIST.TITLE' | translate"
  (emitterEventActionClick)="handleContentAreaEvent($event)"
  [actions]="contentAreaActions"
>
  <app-filter-area
    (emitterEventActionClick)="handleFilterAreaEvent($event)"
  >
    <app-input
      type="text"
      [label]="'EMPLOYEE_LIST.FILTERS.DOCUMENT' | translate"
      [placeholder]="'EMPLOYEE_LIST.FILTERS.DOCUMENT_PLACEHOLDER' | translate"
      [control]="form.get('document')"
      mask="cpf"
    ></app-input>
    <app-input
      type="text"
      [label]="'EMPLOYEE_LIST.FILTERS.SOCIAL_REASON' | translate"
      [placeholder]="'EMPLOYEE_LIST.FILTERS.SOCIAL_REASON_PLACEHOLDER' | translate"
      [control]="form.get('name')"
    ></app-input>
    <app-input
      type="email"
      [label]="'EMPLOYEE_LIST.FILTERS.EMAIL' | translate"
      [placeholder]="'EMPLOYEE_LIST.FILTERS.EMAIL_PLACEHOLDER' | translate"
      [control]="form.get('email')"
    ></app-input>
    <app-select
      label="{{ 'EMPLOYEE_LIST.FILTERS.STATUS.TITLE' | translate }}"
      placeholder="{{ 'EMPLOYEE_LIST.FILTERS.STATUS.PLACEHOLDER' | translate }}"
      [items]="statusOptions"
      [control]="form.get('status')"
    ></app-select>
  </app-filter-area>
  <app-table
    [dataList]="dataList"
    [legends]="tableLegends"
    [displayedColumns]="displayedColumns"
    (emitterEventActionClick)="handleEmitterEventActionClick($event)"
    (sortChanged)="onSortChange($event)"
    [length]="length"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    (paginate)="handlePaginatorClick($event)"
  />
</app-content-area>
